const needDollarSign = ['Total', 'AmountRemaining', 'SubTotal'];
export default needDollarSign;



// WEBPACK FOOTER //
// ./src/constants/need-currency.js